export interface BaseFilterDTO {
  added?: Date;
  updated?: Date;
  statusId?: number;
}

export interface BaseFilterInt extends BaseFilterDTO {
  id?: number;
}

export interface BaseFilterGuid extends BaseFilterDTO {
  id?: string;
}
